import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { videoCardTypes } from '../video-card';
import _get from 'lodash/get';
import {
    getPaginatedList,
    breakPointsName,
    getFocusOnPageFirstItem,
} from '../utils/pagination-utils';
import List from '../list';
import useWindowDimensions from '../hooks/use-window-dimensions';

const Playlist = ({
    topicTitle = '',
    itemsBasePath,
    topicSlug = '',
    onItemClick,
    list = [],
    currentPlayingClipId = '',
    sponsorshipAd = null,
    lang = 'en',
    dictionary = {},
}) => {

    const [
        pageNumber,
        addPage,
    ] = useState(1);
    const [
        focusedItem,
        setFocusedItem,
    ] = useState();
    useEffect(() => {

        const clipIsInPage = paginatedList.filter((item) => item.id === currentPlayingClipId)
            .length;
        if(paginatedList.length && !clipIsInPage) {

            addPage(pages => pages + 1);

        }

    }, [
        currentPlayingClipId,
        paginatedList,
    ]);

    const breakpointData = {
        [breakPointsName.small]: 4,
        [breakPointsName.medium]: 6,
        [breakPointsName.large]: 10,
        [breakPointsName.xl]: 10,
    };

    const { width: currentWidth } = useWindowDimensions();
    const {
        paginatedList,
        moreItemsToPaginate,
        selectedBreakpoint,
    } = getPaginatedList(list, pageNumber, breakpointData, currentWidth);
    const videoCardType = selectedBreakpoint !== breakPointsName.medium
        ? videoCardTypes.LANDSCAPE
        : videoCardTypes.PORTRAIT;

    const pageSize = breakpointData[selectedBreakpoint];
    const paginatedListSize = paginatedList.length;

    const buttonClickHandler = () => {

        addPage(pageNumber + 1);
        const focusedIndex = getFocusOnPageFirstItem(pageSize, paginatedListSize);
        setFocusedItem(focusedIndex);

    };
    const seeMoreText = _get(dictionary, 'see_more_text');
    return (
        <div className="playlist">
            {sponsorshipAd}
            <h2 className="playlist__title">{topicTitle}</h2>
            <List
                className="list"
                hideButton={!moreItemsToPaginate}
                buttonClickHandler={buttonClickHandler}
                listItems={paginatedList}
                onItemClick={onItemClick}
                videoCardType={videoCardType}
                itemsBasePath={itemsBasePath}
                topicSlug={topicSlug}
                currentPlayingClipId={currentPlayingClipId}
                focusIndex={focusedItem}
                lang = {lang}
                buttonText={seeMoreText}
            />
        </div>
    );

};

Playlist.propTypes = {
    itemsBasePath: PropTypes.string.isRequired,
};

export default Playlist;
